export default "__VITE_ASSET__DxkpGPDp__"